<ukg-card has-border *ngIf="showPayCustomerInfos" class="panel-container"
  data-automation="quickactions-component-section">
  <ukg-card-header data-automation="quickactions-component-section-title"
    cardTitle="{{'QUICK_ACTIONS.TITLE' | translate }}" class="card-head"></ukg-card-header>
  <ukg-card-content>
    <ukg-list>
      <ukg-list-item>
        <div class="alerts-component-row" (click)="viewPays()" class="flex-row"
          data-automation="quickactions-component-section-view-pays-btn">
          <ukg-icon name="articles" data-automation="quickactions-component-section-view-pays-icon"></ukg-icon>
          <ukg-label type="primary" class="alerts-label"
            data-automation="quickactions-component-section-view-pays-label" translate>
            QUICK_ACTIONS.VIEW_PAYS</ukg-label>
        </div>
      </ukg-list-item>
      <ukg-list-item *ngIf="showStaleDatedChecks">
        <div class="alerts-component-row" (click)="viewStaleDatedChecks()" class="flex-row"
          data-automation="quickactions-component-section-view-stale-dated-checks-btn">
          <ukg-icon name="articles" data-automation="quickactions-component-section-view-stale-dated-checks-icon"></ukg-icon>
          <ukg-label type="primary" class="alerts-label"
            data-automation="quickactions-component-section-view-stale-dated-checks-label" translate>
            QUICK_ACTIONS.VIEW_STALE_DATED_CHECKS</ukg-label>
        </div>
      </ukg-list-item>
      <ukg-list-item *ngIf="showSendPrenoteFile">
        <div class="alerts-component-row" (click)="viewCompanies()" class="flex-row"
          data-automation="quickactions-component-section-send-prenote-files-btn">
          <ukg-icon name="articles" data-automation="quickactions-component-section-send-prenote-files-icon"></ukg-icon>
          <ukg-label type="primary" class="alerts-label"
            data-automation="quickactions-component-section-send-prenote-files-label" translate>
            QUICK_ACTIONS.SEND_PRENOTE_FILES</ukg-label>
        </div>
      </ukg-list-item>
    </ukg-list>
  </ukg-card-content>
</ukg-card>